import blueGradient from './two-point/blue';
import cyanGradient from './two-point/cyan';
import goldenGradient from './two-point/golden';
import grayGradient from './two-point/gray';
import greenGradient from './two-point/green';
import greenBlueGradient from './two-point/green-blue';
import oceanicGradient from './two-point/oceanic';
import orangeYellowGradient from './two-point/orange-yellow';
import redGradient from './two-point/red';
import redBlueGradient from './two-point/red-blue';
import violetGradient from './two-point/violet';
import violetOrangeGradient from './two-point/violet-orange';
import yellowGradient from './two-point/yellow';

export const TWO_POINT_GRADIENTS = {
    [redGradient.id]: redGradient,
    [greenGradient.id]: greenGradient,
    [blueGradient.id]: blueGradient,
    [violetGradient.id]: violetGradient,
    [yellowGradient.id]: yellowGradient,
    [cyanGradient.id]: cyanGradient,
    [grayGradient.id]: grayGradient,
    [goldenGradient.id]: goldenGradient,
    [oceanicGradient.id]: oceanicGradient,
    [violetOrangeGradient.id]: violetOrangeGradient,
    [orangeYellowGradient.id]: orangeYellowGradient,
    [redBlueGradient.id]: redBlueGradient,
    [greenBlueGradient.id]: greenBlueGradient,
};

export const TWO_POINT_GRADIENT_PALETTES = {
    redGradient,
    grayGradient,
    blueGradient,
    cyanGradient,
    violetGradient,
    yellowGradient,
    violetOrangeGradient,
    orangeYellowGradient,
    redBlueGradient,
    greenGradient,
    greenBlueGradient,
    goldenGradient,
    oceanicGradient,
};
